import { useMicrocopy } from '@lib/cms/microcopy/client';
import { c } from '@ui-components/utils/tailwind-merge';
import {
  MINI_CART_MICROCOPY_DEFAULTS,
  MINI_CART_MICROCOPY_SET,
} from '../miniCartMicrocopy';
import { MiniCartLoadingProps } from './MiniCartLoading.types';

/** Shown while the island chunk, the session or the cart is loading. */
export const MiniCartLoading = ({ className = '' }: MiniCartLoadingProps) => {
  const mc = useMicrocopy(
    MINI_CART_MICROCOPY_SET,
    MINI_CART_MICROCOPY_DEFAULTS
  );
  return (
    <div
      role="status"
      data-test="mini-cart-loading"
      className={c('flex flex-1 items-center justify-center p-10', className)}
    >
      <span
        aria-hidden="true"
        className="h-8 w-8 animate-spin rounded-full border-4 border-grey-200 border-t-blue"
      />
      <span className="sr-only">{mc['mini-cart.loading']}</span>
    </div>
  );
};
